import React from "react";
import Layout from "../components/layout/Cslayout";

const EmployeeAdminDashboard = () => {
  return (
    <Layout>
      <div>EmployeeAdminDashboard</div>
    </Layout>
  );
};

export default EmployeeAdminDashboard;
